<template>
  <div class="page-container" id="page-container">
    <div class="page-title padding pb-0 ">
      <h2 class="text-md mb-0">{{ $t('message.Configuration.title') }}</h2>
    </div>
    <div class="padding">
      <div class="row">
        <div class="col-md-12">
          <div class="card card-form">
            <div v-if="configurationLoading === true" class="h-100 d-flex justify-content-center align-items-center">
              <img alt="Vue logo" src="@/assets/img/loading.gif" width="100px" height="100px">
            </div>

            <div v-else class="card-body">
              <div class="form-section-header">{{ $t('message.Configuration.headerColor') }}</div>

              <div class="row">
                <div class="col" :style="`background-color: ${colors.hex}`">
                  
                </div>
                <div class="col">
                  <photoshop-picker v-model="colors" />
                </div>
              </div>

              <div class="form-section-header">{{ $t('message.Configuration.googleAdsScript') }}</div>
              <div class="row">
                <textarea class="form-control" v-model="googleAdsScript" rows="10"></textarea>
              </div>

              <div class="form-buttons">
                <button type="submit" class="btn btn-warning mr-2" @click="proceedDefault">{{ $t('message.Configuration.restoreDefault') }} </button>
                <button type="submit" class="btn btn-success" @click="proceed">{{ $t('message.Configuration.save') }} </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import {CONFIGURATION_REQUEST, CONFIGURATION_COMMIT} from '@/store/actions/configuration';

  import { Photoshop } from 'vue-color'

  import firebase from 'firebase/app';

  export default {
    name: "Impressum",
    components: {
      'photoshop-picker': Photoshop
    },

    data() {
      return {
        editor: ClassicEditor,
        editorData: '',
        editorConfig: {
          // The configuration of the editor.
        },

        commit: false,

        colors: {hex: '#20283d'},
        googleAdsScript: '',
      }
    },

    methods: {
      proceed() {
        this.$validator.validate().then(result => {
          if (!result) {
            this.$swal({
              title: 'Error!',
              text: this.$t("message.Book.errors.fillRequiredFields"),
              type: 'error',
              confirmButtonText: 'OK'
            });

            this.showValidateErrors = true;
          } else {
            return this.saveRow();
          }
        });
      },

      async saveRow() {
        this.$store.dispatch(CONFIGURATION_COMMIT, {header_bg_color: this.colors.hex, google_ads_script: this.googleAdsScript})
          .then(() => {
            this.$swal({
              title: this.$t("message.success"),
              text: this.$t("message.successfullySaved"),
              type: 'success',
              confirmButtonText: 'OK'
            }).then(() => {
              this.$router.push({name: 'Configuration'});
            })
          })
          .catch(err => {
            alert('error')
            console.log(err)
          })
      },

      proceedDefault() {
        this.$swal({
          title: this.$t("message.Configuration.restoreDefault"),
          html: this.$t("message.Configuration.restoreDefaultInfo"),
          type: 'info',
          confirmButtonText: this.$t("message.Configuration.restore"),
          showCancelButton: true,
        })
            .then(value => {
              if(value.value != undefined) {
                this.colors = {hex: '#20283d'};
              }
            });
      }
    },

    computed: {
    },

    mounted() {
      this.$store.dispatch(CONFIGURATION_REQUEST)
          .then(() => {
            this.colors.hex = this.configuration.header_bg_color;
            this.googleAdsScript = this.configuration.google_ads_script;
          });
    },
  }
</script>

<style scoped>
</style>